import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';

interface Props {
    onBack: () => void;
}

const useStyles = makeStyles((theme: any) => ({
    panel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem',
        width: '100%',
        maxWidth: '34rem',
        margin: '0 auto',
        padding: '2.5rem 2rem',
        boxSizing: 'border-box',
        textAlign: 'center',
        background: theme.palette.common.white,
        border: theme.border.light,
        borderRadius: theme.radius.default,
        [theme.breakpoints.down('xs')]: {
            padding: '2rem 1.25rem',
        },
    },
    badge: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '3.5rem',
        height: '3.5rem',
        marginBottom: '0.25rem',
        borderRadius: '50%',
        background: theme.palette.common.cream,
    },
    icon: {
        fontSize: '1.75rem',
        color: theme.palette.common.midGrey,
    },
    title: {
        margin: 0,
        fontSize: '1.125rem',
        fontWeight: theme.weight.heading,
        color: theme.palette.common.darkGrey,
    },
    text: {
        margin: 0,
        color: theme.palette.common.darkGrey,
        opacity: 0.7,
    },
    link: {
        padding: 0,
        border: 'none',
        background: 'none',
        font: 'inherit',
        color: 'inherit',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.common.darkGrey}`,
            outlineOffset: '2px',
        },
    },
}));

export const SearchNoResults = ({ onBack }: Props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const backLink = (
        <button type="button" className={classes.link} onClick={onBack} data-testid="search-no-results-back">
            {t('NoSearchResultsBackLink')}
        </button>
    );

    return (
        <div className={classes.panel} data-testid="search-no-results">
            <span className={classes.badge}>
                <SearchIcon className={classes.icon} />
            </span>
            <p className={classes.title}>{t('NoSearchResultsTitle')}</p>
            <p className={classes.text}>
                {t('NoSearchResultsText')} {backLink}.
            </p>
        </div>
    );
};
